export default "__VITE_ASSET__D5yv$zim__"